import React from 'react';

import Icons from 'assets/icons';

interface QuoteProps {
  text?: string;
  author?: string;
}

const Quote = ({ text, author }: QuoteProps): React.JSX.Element => (
  <div className="flex mobile:flex-col tablet:flex-row bg-blue-100 p-6 rounded-md mobile:mb-6 xs:mb-8">
    <div className="w-12 h-8">
      <Icons.QuoteMark width={28} height={32} />
    </div>
    <div className="mobile:pt-2 tablet:pt-0 tablet:pl-4">
      <div className="font-semibold text-lg text-blue-800">{text}</div>
      <div className="italic text-sm text-blue-800 pt-4">{author}</div>
    </div>
  </div>
);

export default Quote;
